import React, { useState, useEffect } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { Col, Row, Input } from "reactstrap" // Import Input from reactstrap for better styling
import { Fn_AddEditData, Fn_DisplayData } from "../../store/Functions"
import { useDispatch } from "react-redux"
import { API_WEB_URLS } from "../../constants/constAPI"
import { useLocation, useNavigate } from "react-router-dom"

function AddEdit_BankMaster() {
  const API_URL_SAVE = "LedgerMaster/0/token"
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/LedgerEdit/Id"

  const [state, setState] = useState({
    id: 0,
    FillArray: [
      { Id: 12, Name: "Bank Accounts" },
      { Id: 16, Name: "Cash In hand" },
      // { Id: 44, Name: "Party A/c" },
    ],
    formData: {},
    isProgress: true,
  })

  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0

    if (Id > 0) {
      setState((prevState) => ({
        ...prevState,
        id: Id,
      }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    }
  }, [dispatch, location.state])

  // Validation Schema
  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
    F_LedgerGroupMaster: Yup.number()
      .required("Ledger Group Master is required")
      .positive("Please select a valid Ledger Group")
      .min(1),
    AccountNo: Yup.string()
      .matches(/^[0-9]{10}$/, "Account number must be 10 digits")
      .nullable(),
    MobileNo: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
      .nullable(),
  })

  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    let formData = new FormData()
    formData.append("Name", values.Name)
    formData.append("F_LedgerGroupMaster", values.F_LedgerGroupMaster)
    formData.append("AccountNo", values.AccountNo || 0)
    formData.append("MobileNo", values.MobileNo || 0)
    formData.append("F_PumpMaster", obj.uid)
    formData.append("UserId", obj.Id)
    
    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/BankMaster"
    )
  }

  return (
    <div className="page-content">
      <Formik
        initialValues={{
          ...state.formData,
          F_LedgerGroupMaster: state.formData.F_LedgerGroupMaster || -1,
          AccountNo: state.formData.AccountNo || "",
          MobileNo: state.formData.MobileNo || "",
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
            {/* Ledger Group Dropdown */}
            <Row>
              <Col lg="2">
                <label htmlFor="F_LedgerGroupMaster" className="form-label">
                  Ledger Group Master
                </label>
              </Col>
              <Col lg="6" className="mb-3">
                <Input
                  type="select"
                  name="F_LedgerGroupMaster"
                  onChange={(e) => setFieldValue("F_LedgerGroupMaster", e.target.value)}
                  value={values.F_LedgerGroupMaster}
                >
                  <option value={-1}>Select Ledger Group</option>
                  {state.FillArray.map((type) => (
                    <option key={type.Id} value={type.Id}>
                      {type.Name}
                    </option>
                  ))}
                </Input>
                <ErrorMessage
                  name="F_LedgerGroupMaster"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>

            {/* Name Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="Name" className="form-label">
                  Name
                </label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field
                  className="form-control"
                  type="text"
                  name="Name"
                  placeholder="ex : Shyam Sharma"
                />
                <ErrorMessage name="Name" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Account Number Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="AccountNo" className="form-label">
                  Account Number
                </label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field
                  className="form-control"
                  type="text"
                  name="AccountNo"
                  placeholder="Enter Account Number"
                />
                <ErrorMessage name="AccountNo" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Mobile Number Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="MobileNo" className="form-label">
                  Mobile Number
                </label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field
                  className="form-control"
                  type="text"
                  name="MobileNo"
                  placeholder="Enter Mobile Number"
                />
                <ErrorMessage name="MobileNo" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Submit Button */}
            <button type="submit" className="btn btn-primary btn-block">
              Submit
            </button>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default AddEdit_BankMaster
